site.up = {
	init: function () {
		var $w = $(window),
			goUp = $('#up');

		$w.scroll(function () {
			if ($('body').width() > 1400 - 15) {
				if ($w.scrollTop() > 500) {
					goUp.fadeIn();
				} else {
					goUp.fadeOut();
				}
			}
		});
		goUp.click(function(e) {
			$('html,body').animate({
				scrollTop:0
			},300);
			e.preventDefault();
		});
	}
};

site.inits.push('site.up.init()');
